<template>
  <div>
    <div
      v-if="loading"
      class="text-center p-5"
    >
      Loading form...
    </div>
    <div
      v-else-if="loadError"
      class="text-center p-5 text-danger"
    >
      {{ loadError }}
    </div>
    <template v-else>
      <div>
        <div class="formWrapper niche-wr filled">
          <b-row>
            <b-col cols="12">
              <div class="form-header floatCss">
                <b-row>
                  <b-col cols="12">
                    <div class="form-header-inner d-flex justify-content-between">
                      <div class="d-flex">
                        <div class="dForm-top-logo">
                          <img :src="logoSrc">
                        </div>
                        <div class="dForm-companyDetails">
                          <div class="dForm-cmBlock">
                            <h2>
                              <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                            </h2>
                          </div>
                          <div class="dForm-cmBlock2">
                            <p>(Co. Reg. No. 200401183W)</p>
                            <p>(GST Group Reg. No. M90364395L)</p>
                          </div>
                        </div>
                      </div>
                      <div class="dForm-top-right d-flex">
                        <h5 class="text-block font-small-12">
                          NV-SG-CSD-F18 REV: 7
                        </h5>
                        <h5>File No: {{ formData.fileNo || '-' }}</h5>
                        <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="pp-section-tittle">
                      <h2>sales order - funeral service package (FSP) 富贵殡仪配套认购同意书</h2>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row class="payment-plan-section">
            <b-col cols="12">
              <b-row>
                <b-col cols="12">
                  <div class="pp-section-tittle">
                    <h3>Need Type: <strong>Pre-need</strong></h3>
                    <p>I hereby agree to purchase FSP at the purchase price specified herein upon the terms and subject to the conditions stated overleaf.</p>
                    <h4>本人同意購買下列殯儀配套,售價註明如下,並遵守背頁所附的條件。</h4>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="ssfp-form-wrapper">
            <b-col cols="12">
              <b-row>
                <b-col cols="12">
                  <div class="pp-section-tittle2">
                    <h2>PARTICULARS of purchaser 购买者资料</h2>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col cols="12">
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      Full Name as in NRIC / Passport <br>身份证 / 护照上的全名
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.customerName || '-' }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col
                  cols="7"
                  md="7"
                  lg="7"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      NRIC/ Passport No <br>身份证/ 护照号码
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.customerNric || '-' }}
                    </div>
                  </div>
                </b-col>
                <b-col
                  cols="5"
                  md="5"
                  lg="5"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-2">
                      Nationality <br>国籍
                    </div>
                    <div class="ssfp-text-field-input-2">
                      {{ formData.customerNationality || '-' }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col
                  cols="7"
                  md="7"
                  lg="7"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      Birth Date <br>出生日期
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.customerDob || '-' }}
                    </div>
                  </div>
                </b-col>
                <b-col
                  cols="5"
                  md="5"
                  lg="5"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-2">
                      Sex <br>性別
                    </div>
                    <div class="ssfp-text-field-input-3">
                      <div
                        class="ssfp-check-box"
                        :class="{ active: formData.customerSex === 'Male' }"
                      >
                        Male 男
                      </div>
                      <div
                        class="ssfp-check-box"
                        :class="{ active: formData.customerSex === 'Female' }"
                      >
                        Female 女
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col cols="12">
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      Permanent Address <br>永久地址
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.permanentAddress }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col cols="12">
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      Correspondence Address <br>通讯地址
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.correspondenceAddress }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col
                  cols="7"
                  md="7"
                  lg="7"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-1">
                      E-mail Address <br>电邮
                    </div>
                    <div class="ssfp-text-field-input-1">
                      {{ formData.customerEmail || '-' }}
                    </div>
                  </div>
                </b-col>
                <b-col
                  cols="5"
                  md="5"
                  lg="5"
                >
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-2">
                      Contact No. <br>联络号码
                    </div>
                    <div class="ssfp-text-field-input-2">
                      {{ formData.customerContact || '-' }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div class="pp-section-tittle2">
                    <h2>PARTICULARS of intended user 受提名使用者资料</h2>
                  </div>
                </b-col>
              </b-row>
              <div
                v-for="(item, index) in formData.intendedUsers"
                :key="index"
              >
                <b-row
                  :key="'row1-' + index"
                  class="ssfp-single-row"
                >
                  <b-col
                    cols="7"
                    md="7"
                    lg="7"
                  >
                    <div class="ssfp-text-field-row floatCss">
                      <div class="ssfp-text-field-single ssfp-field-width-1">
                        Name <br>姓名
                      </div>
                      <div class="ssfp-text-field-input-1">
                        {{ item.name || '-' }}
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    cols="5"
                    md="5"
                    lg="5"
                  >
                    <div class="ssfp-text-field-row floatCss">
                      <div class="ssfp-text-field-single ssfp-field-width-2">
                        NRIC No. <br>身份证号码
                      </div>
                      <div class="ssfp-text-field-input-2">
                        {{ item.nric || '-' }}
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row
                  :key="'row2-' + index"
                  class="ssfp-single-row"
                  :class="{ 'custom-gap-10': index !== formData.intendedUsers.length - 1 }"
                >
                  <b-col
                    cols="7"
                    md="7"
                    lg="7"
                  >
                    <div class="ssfp-text-field-row floatCss">
                      <div class="ssfp-text-field-single ssfp-field-width-1">
                        Birth Date <br>出生日期
                      </div>
                      <div class="ssfp-text-field-input-1">
                        {{ item.dob ? dateFormat(item.dob) : '-' }}
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    cols="5"
                    md="5"
                    lg="5"
                  >
                    <div class="ssfp-text-field-row floatCss">
                      <div class="ssfp-text-field-single ssfp-field-width-2">
                        Relationship <br>关系
                      </div>
                      <div class="ssfp-text-field-input-2">
                        {{ item.relation || '-' }}
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div class="pp-section-tittle2">
                    <h2>total purchase price 购买价格</h2>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <div class="ssfp-pl-block floatCss">
                    <h3>{{ formData.packageName }} <span>(This Purchase Order serves as a Tax Invoice if GST is charged)</span></h3>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-pl-single-row">
                <b-col
                  cols="6"
                  md="6"
                  lg="6"
                >
                  <div class="ssfp-pl-block floatCss">
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        FSP Package Price 骨灰灵位价格
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        $ {{ numberFormat(formData.productPrice) }}
                      </div>
                    </div>
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        Others 其他
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        $ {{ formData.otherFee ? numberFormat(formData.otherFee) : '-' }}
                      </div>
                    </div>
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        GST 消费税 {{ formData.gstPercentage || 9 }}%
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        $ {{ numberFormat(formData.gstAmount || 0) }}
                      </div>
                    </div>
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        <strong>Total 总额</strong>
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        <strong>$ {{ numberFormat(formData.totalAmount || 0) }}</strong>
                      </div>
                    </div>
                  </div>
                </b-col>
                <b-col
                  cols="6"
                  md="6"
                  lg="6"
                >
                  <div class="ssfp-pl-block-right nsf-right3 floatCss">
                    <h3>NOTES</h3>
                    <ol class="notelist-rtd">
                      <li>This purchase shall be subject to the attached Terms And Conditions, the contents of which I have read and fully understood.</li>
                      <li>This Sales Order Serves as a Tax Invoice if GST is changed.</li>
                      <li>
                        <ol>
                          <li>All payments must be made payable to "Nirvana Memorial Garden Pte. Ltd.". Confirmation of purchase is subject to clearance of the cheques. Please write your File No. and Name of the payee on the reverse side of the cheque.</li>
                          <li>A Sales Order must be received and accepted by Nirvana Memorial Garden Pte. Ltd. to be valid and binding on Nirvana Memorial Garden Pte. Ltd..</li>
                        </ol>
                      </li>
                    </ol>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <!-- eslint-disable-next-line vue/html-self-closing -->
        <div class="page-break-after"></div>
        <div class="formWrapper filled">
          <b-row>
            <b-col cols="12">
              <div class="form-header floatCss">
                <b-row>
                  <b-col cols="12">
                    <div class="form-header-inner d-flex justify-content-between">
                      <div class="d-flex">
                        <div class="dForm-top-logo">
                          <img :src="logoSrc">
                        </div>
                        <div class="dForm-companyDetails">
                          <div class="dForm-cmBlock">
                            <h2>
                              <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                            </h2>
                          </div>
                          <div class="dForm-cmBlock2">
                            <p>(Co. Reg. No. 200401183W)</p>
                            <p>(GST Group Reg. No. M90364395L)</p>
                          </div>
                        </div>
                      </div>
                      <div class="dForm-top-right d-flex">
                        <h5 class="text-block font-small-12">
                          NV-SG-CSD-F18 REV: 7
                        </h5>
                        <h5>File No: {{ formData.fileNo || '-' }}</h5>
                        <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="pp-section-tittle">
                      <h2>sales order - funeral service package (FSP) 富贵殡仪配套认购同意书</h2>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-form-wrapper">
            <b-col cols="12">
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div class="pp-section-tittle2">
                    <h2>PARTICULARS of Sales and Service Agent  销售代理及服务代理资料</h2>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-pl-single-row">
                <b-col
                  cols="8"
                  md="8"
                  lg="8"
                >
                  <div class="ssfp-pl-block floatCss">
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        Agency 区代理
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        {{ formData.salesAgentAgency }}
                      </div>
                    </div>
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        Sales Agent 销售代理
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        {{ formData.salesAgentName }}
                      </div>
                    </div>
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        Agency 区代理
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        {{ formData.serviceAgentAgency }}
                      </div>
                    </div>
                    <div class="ssfp-pl-list floatCss">
                      <div class="ssfp-pl-left-label floatCss">
                        Service Agent 服务代理
                      </div>
                      <div class="ssfp-pl-right-amount floatCss">
                        {{ formData.serviceAgentName }}
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div class="pp-section-tittle2">
                    <h2>Personal Data Consent 个人资料使用同意书</h2>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div class="pp-ssfp-check-info nsf-cm-1 active floatCss">
                    I further declare that the Company has made available to me, the Company’s Customer Privacy Policy Statement (“Statement”) as required under the Personal Data Protection Act (Act 26 of 2012), and having read and inspected the same, hereby agree that I consent to the Company processing my personal data, and confirm that I have authority to provide the personal data of any third parties for processing by the Company in accordance with the Notice.
                  </div>
                </b-col>
              </b-row>
              <template v-if="formData.showPurchaseDeclaration">
                <b-row>
                  <b-col
                    cols="12"
                    class="custom-gap-10"
                  >
                    <div class="pp-section-tittle2">
                      <h2>purchase DECLARATION 购买声明</h2>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="12"
                    class="custom-gap-10"
                  >
                    <div class="pp-ssfp-check-info active floatCss">
                      <p>I have on this date purchased the Funeral Service Package(s) <strong>{{ formData.purchasedLotsText }}</strong> from Nirvana Memorial Garden Pte. Ltd. and I declared and acknowledge that the purchase was:-</p>
                      <ol>
                        <li>Voluntarily concluded;</li>
                        <li>Made with full understanding of the product;</li>
                        <li>Made with awareness and understanding that speculation of the said product(s) is discouraged and that I will not hold the Company responsible in any way on the re-sale of the same in the secondary market.</li>
                      </ol>
                    </div>
                  </b-col>
                </b-row>
              </template>
              <template v-if="formData.isAgentPurchase">
                <b-row>
                  <b-col cols="12">
                    <div class="pp-section-tittle2">
                      <h2>agent self purchase DECLARATION 代理人自购声明</h2>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="12"
                    class="custom-gap-10"
                  >
                    <div class="nsf-custom-tittle1 floatCss">
                      <h4>Cooling-Off Period</h4>
                      <p>Where the Service Advisor is a purchaser of any product, the "Cooling-Off" period shall be sixty (60) days.</p>
                      <h4>Refund During Cooling-Off Period</h4>
                      <ol>
                        <li>
                          Refund request must be submitted within the "Cooling-Off" period by completing the relevant Form(s) as follow:
                          <ol>
                            <li>
                              <h5>For cancellation and refund</h5>
                              <p>Complete Form II and submit the signed Form II together with customer copy of Sales Order and all temporary receipt/official receipt.</p>
                            </li>
                            <li>
                              <h5>For cancellation and transfer payment to other file(s) under same purchaser</h5>
                              <p>Complete Form I and submit the signed Form I together with customer copy of Sales Order and all temporary receipt/official receipt.</p>
                            </li>
                          </ol>
                        </li>
                        <li>The refund shall be subject to such deduction (i.e. processing fee, terminal charges and etc) as may be appropriate.</li>
                        <li>Refund will be made to Purchaser within 30 days upon receipt of signed form with complete submission of all required documents.</li>
                      </ol>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="12"
                    class="custom-gap-10"
                  >
                    <div class="pp-ssfp-check-info nsf-cm-1 active floatCss">
                      I acknowledge this is an agent purchase and the terms of the cooling-off period that applies to agent purchases.
                    </div>
                  </b-col>
                </b-row>
              </template>
              <template v-if="!(formData.showPurchaseDeclaration && formData.isAgentPurchase)">
                <b-row>
                  <b-col
                    cols="12"
                    class="custom-gap-10"
                  >
                    <div class="pp-section-tittle2">
                      <h2>marketing consent 声明</h2>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="pp-section-tittle3 floatCss">
                      <p>From time to time, the Group may use personal data disclosed by you in this Form to send you advertising and promotional material. If you do not wish to receive such material, kindly check the box below.</p>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="12"
                    class="custom-gap-10"
                  >
                    <div
                      class="pp-ssfp-check-info floatCss"
                      :class="{ 'active': formData.marketingDataConsent == 'true' }"
                    >
                      No, I would not like to receive advertising and promotional material from the Group.
                    </div>
                  </b-col>
                </b-row>
              </template>
            </b-col>
          </b-row>
          <b-row
            v-if="!(formData.showPurchaseDeclaration && formData.isAgentPurchase)"
            class="ssfp-signature"
          >
            <b-col cols="12">
              <div class="pp-signature-area floatCss">
                <p>Purchaser 购买者签名</p>
              </div>
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col
                  cols="6"
                  md="6"
                  lg="6"
                >
                  <div
                    v-if="formData.signOne"
                    class="pp-signature-block floatCss"
                  >
                    <img
                      :src="formData.signOne"
                      alt="signature"
                    >
                  </div>
                  <div
                    v-else
                    id="signOne"
                    class="pp-signature-block signature-block-yellow floatCss"
                  >
                    <span>Sign here</span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <div class="pp-signature-area floatCss">
                <h4>Name 姓名: {{ formData.customerName }}</h4>
                <h4>Date 日期: {{ (formData.signOneDate ? dateFormatWithTime(formData.signOneDate) : '') }}</h4>
              </div>
            </b-col>
          </b-row>
        </div>
        <!-- eslint-disable-next-line vue/html-self-closing -->
        <div
          v-if="formData.showPurchaseDeclaration && formData.isAgentPurchase"
          class="page-break-after"
        ></div>
        <div
          v-if="formData.showPurchaseDeclaration && formData.isAgentPurchase"
          class="formWrapper filled"
        >
          <b-row>
            <b-col cols="12">
              <div class="form-header floatCss">
                <b-row>
                  <b-col cols="12">
                    <div class="form-header-inner d-flex justify-content-between">
                      <div class="d-flex">
                        <div class="dForm-top-logo">
                          <img :src="logoSrc">
                        </div>
                        <div class="dForm-companyDetails">
                          <div class="dForm-cmBlock">
                            <h2>
                              <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                            </h2>
                          </div>
                          <div class="dForm-cmBlock2">
                            <p>(Co. Reg. No. 200401183W)</p>
                            <p>(GST Group Reg. No. M90364395L)</p>
                          </div>
                        </div>
                      </div>
                      <div class="dForm-top-right d-flex">
                        <h5 class="text-block font-small-12">
                          NV-SG-CSD-F18 REV: 7
                        </h5>
                        <h5>File No: {{ formData.fileNo || '-' }}</h5>
                        <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="pp-section-tittle">
                      <h2>sales order - funeral service package (FSP) 富贵殡仪配套认购同意书</h2>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-form-wrapper">
            <b-col cols="12">
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div class="pp-section-tittle2">
                    <h2>marketing consent 声明</h2>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <div class="pp-section-tittle3 floatCss">
                    <p>From time to time, the Group may use personal data disclosed by you in this Form to send you advertising and promotional material. If you do not wish to receive such material, kindly check the box below.</p>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  class="custom-gap-10"
                >
                  <div
                    class="pp-ssfp-check-info floatCss"
                    :class="{ 'active': formData.marketingDataConsent == 'true' }"
                  >
                    No, I would not like to receive advertising and promotional material from the Group.
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="ssfp-signature">
            <b-col cols="12">
              <div class="pp-signature-area floatCss">
                <p>Purchaser 购买者签名</p>
              </div>
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col
                  cols="6"
                  md="6"
                  lg="6"
                >
                  <div
                    v-if="formData.signOne"
                    class="pp-signature-block floatCss"
                  >
                    <img
                      :src="formData.signOne"
                      alt="signature"
                    >
                  </div>
                  <div
                    v-else
                    id="signOne"
                    class="pp-signature-block signature-block-yellow floatCss"
                  >
                    <span>Sign here</span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <div class="pp-signature-area floatCss">
                <h4>Name 姓名: {{ formData.customerName }}</h4>
                <h4>Date 日期: {{ (formData.signOneDate ? dateFormatWithTime(formData.signOneDate) : '') }}</h4>
              </div>
            </b-col>
          </b-row>
        </div>
        <!-- eslint-disable-next-line vue/html-self-closing -->
        <div
          class="page-break-after"
        ></div>
        <div
          class="formWrapper filled"
        >
          <b-row>
            <b-col cols="12">
              <div class="form-header floatCss">
                <b-row>
                  <b-col cols="12">
                    <div class="form-header-inner d-flex justify-content-between">
                      <div class="d-flex">
                        <div class="dForm-top-logo">
                          <img :src="logoSrc">
                        </div>
                        <div class="dForm-companyDetails">
                          <div class="dForm-cmBlock">
                            <h2>
                              <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                            </h2>
                          </div>
                          <div class="dForm-cmBlock2">
                            <p>(Co. Reg. No. 200401183W)</p>
                            <p>(GST Group Reg. No. M90364395L)</p>
                          </div>
                        </div>
                      </div>
                      <div class="dForm-top-right d-flex">
                        <h5 class="text-block font-small-12">
                          NV-SG-CSD-F18 REV: 7
                        </h5>
                        <h5>File No: {{ formData.fileNo || '-' }}</h5>
                        <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="pp-section-tittle">
                      <h2>sales order - funeral service package (FSP) 富贵殡仪配套认购同意书</h2>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-top-20"
            >
              <div class="pp-section-tittle2">
                <h2>TERMS & CONDITIONS</h2>
                <h3>The Purchaser agrees to purchase the Funeral Service Package("Package") upon the following terms and conditions:</h3>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-top-20"
            >
              <div class="tc-single-wrapper floatCss">
                <div class="pp-section-tittle2 floatCss">
                  <h4>TERM</h4>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    1
                  </div>
                  <div class="tc-info-rt">
                    <p>In consideration of the sum specified herein paid by the Purchaser to NIRVANA MEMORIAL GARDEN PTE. LTD. [Company No. 200720733M] (Company), the Company shall sell the Package to the Purchaser.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    2
                  </div>
                  <div class="tc-info-rt">
                    <p>If the purchase of the Package is made pursuant to purchase of any other products specially promoted by the Company (Special Product"), then the acceptance of this Purchase Order is conditional upon the Purchaser fulfilling all his obligations in the contract of purchase of the Special Product.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    3
                  </div>
                  <div class="tc-info-rt">
                    <p>The Package shall be exercised strictly in the Republic of Singapore (hereinafter referred to as "the Territory").</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    4
                  </div>
                  <div class="tc-info-rt">
                    <p>If any transaction is not finalized within 10 days of the deposit being paid, the said transaction will be deemed terminated, and the deposit will be refunded, lass 10% for processing fees. Thereafter the Purchaser shall not have any claim against Nirvana Memorial Garden Pte. Ltd. in respect thereof.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    5
                  </div>
                  <div class="tc-info-rt">
                    <p>The Purchaser shall only be permitted to exercise and utilize the Package after thirty (30) days from the date of this Purchase Order. Any utilization of the Package within thirty days from the date of this Purchase Order shall be treated as an As-Need case and As-Need prices will apply.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    6
                  </div>
                  <div class="tc-info-rt">
                    <p>If the Company is unable to deliver and provide the Package as a result of circumstances beyond its control, the Company will refund in full all monies paid by the Purchaser free of interest. The Package (or any of its items) is not refundable or returnable for whatsoever reason except for the circumstances mentioned in this clause herein.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    7
                  </div>
                  <div class="tc-info-rt">
                    <p>Unless an intended user is nominated herein the Purchaser shall be deemed the person for whom the Package is purchased and made available.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    8
                  </div>
                  <div class="tc-info-rt">
                    <p>The Purchaser is at liberty prior to the exercise of his rights in the Package to nominate an intended user and may from time to time nominate another in substitution (Intender User"). Each new nomination of Intended User shall be submitted by the Purchaser and the same shall be acknowledged receipt by the Company.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    9
                  </div>
                  <div class="tc-info-rt">
                    <p>The Company shall deliver and provide the Package upon report of the demise of the Intended User and provided that the purchase price of the Package has been paid and settled in full. A copy of the death certificate shall be conclusive proof of death.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    10
                  </div>
                  <div class="tc-info-rt">
                    <p> In the event that any of the items comprised in the Package are not suitable for the Purchaser or the Intended User by reason of his culture, belief or consciences or due to any peculiarity of which the Company has no written notice in whatsoever manner or any of the goods is not acceptable to the Purchaser or the Intended User or any of the services is incapable of performance due to any fault not contributed by the Company, no refund on the whole or any part of the price herein shall be allowed and neither is the Purchaser entitled to repudiate this Purchase Order.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    11
                  </div>
                  <div class="tc-info-rt">
                    <p>The Company shall issue a certificate of purchase ("Certificate") to the Purchaser and the same shall be submitted to the Company when the Package is called upon and utilized.</p>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
        <!-- eslint-disable-next-line vue/html-self-closing -->
        <div class="page-break-after"></div>
        <div class="formWrapper filled">
          <b-row>
            <b-col cols="12">
              <div class="form-header floatCss">
                <b-row>
                  <b-col cols="12">
                    <div class="form-header-inner d-flex justify-content-between">
                      <div class="d-flex">
                        <div class="dForm-top-logo">
                          <img :src="logoSrc">
                        </div>
                        <div class="dForm-companyDetails">
                          <div class="dForm-cmBlock">
                            <h2>
                              <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                            </h2>
                          </div>
                          <div class="dForm-cmBlock2">
                            <p>(Co. Reg. No. 200401183W)</p>
                            <p>(GST Group Reg. No. M90364395L)</p>
                          </div>
                        </div>
                      </div>
                      <div class="dForm-top-right d-flex">
                        <h5 class="text-block font-small-12">
                          NV-SG-CSD-F18 REV: 7
                        </h5>
                        <h5>File No: {{ formData.fileNo || '-' }}</h5>
                        <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="pp-section-tittle">
                      <h2>sales order - funeral service package (FSP) 富贵殡仪配套认购同意书</h2>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-top-20"
            >
              <div class="tc-single-wrapper floatCss">
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    12
                  </div>
                  <div class="tc-info-rt">
                    <p>The Purchaser shall report to the Company if the Certificate is lost, destroyed or misplaced before a duplicate certificate can be issued and subject to the payment of an administration fee as imposed by the Company.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    13
                  </div>
                  <div class="tc-info-rt">
                    <p>The Purchaser is at liberty at any time to transfer his/her rights to the Package subject to the Purchaser furnishing the Certificate and paying a transfer fee at 2% of the prevailing sale price or $100.00 (plus prevailing GST rate), whichever is higher provided that at the time of transfer the Package has not been exercised.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    14
                  </div>
                  <div class="tc-info-rt">
                    <p>If the Purchaser intends to settle the balance purchase price by easy payment scheme, the Company's right to such amount under the easy payment scheme will crystalize only on the specified agreed payment dates. Should the Purchaser fail to make full amount of any payment under the easy payment scheme within a period of thirty (30) days after the agreed payment date, this purchase shall be deemed terminated forthwith. Consequently all monies paid to account of the purchase price shall be forfeited absolutely by the Company.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    15
                  </div>
                  <div class="tc-info-rt">
                    <p>The balance purchase price will be immediately due and payable upon the exercise of the Package. Nothing in this Purchase Order precludes the Company's right to recover any balance purchase price from the Purchaser where the Package has been exercised.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    16
                  </div>
                  <div class="tc-info-rt">
                    <p>All notices required to be given shall be in writing. Any notice to the Purchaser shall be sufficiently served if sent by prepaid post addressed to the Purchaser at the Purchaser's address herein stated or to the Purchaser's last known address. It is the Purchaser's duty to inform the Company in writing of any change of address.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    17
                  </div>
                  <div class="tc-info-rt">
                    <p>The total purchase price ("Price") for the Package as referred to in this Purchase Order and such other fees and charges ("Fees") stipulated therein is inclusive of Goods & Service Tax (GST") imposed by the government of Singapore, where applicable. If the Price and the Fees are subject to such other additional charges, duties, fees, levies or any such other tax (collectively referred to as "Tax") which may be imposed from time to time by the government or any statutory authority in Singapore at any time after execution of the Purchase Order, notwithstanding any provisions stipulated herein, the Purchaser, unequivocally agrees and accepts that, in addition to the Price [whether already paid in full or in part] and the Fees, the Purchaser, shall pay the additional Tax at the rate imposed by the government or any statutory authority in Singapore when notified to do so.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    18
                  </div>
                  <div class="tc-info-rt">
                    <p>The choice of parlour to be used shall be made at the Company's discretion from the list of the Company's approved parlour venues. Use of any other parlour venue shall beis subject to additional charges.</p>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    19
                  </div>
                  <div class="tc-info-rt">
                    <p>The terms and conditions in the English language shall prevail over the Chinese language should any conflict arise in the interpretation of the terms and conditions hereto.</p>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-signature">
            <b-col cols="12">
              <div class="pp-signature-area floatCss">
                <p>Purchaser 购买者签名</p>
              </div>
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col
                  cols="6"
                  md="6"
                  lg="6"
                >
                  <div
                    v-if="formData.signTwo"
                    class="pp-signature-block floatCss"
                  >
                    <img
                      :src="formData.signTwo"
                      alt="signature"
                    >
                  </div>
                  <div
                    v-else
                    id="signTwo"
                    class="pp-signature-block signature-block-yellow floatCss"
                  >
                    <span>Sign here</span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <div class="pp-signature-area floatCss">
                <h4>Name 姓名: {{ formData.customerName }}</h4>
                <h4>Date 日期: {{ (formData.signTwoDate ? dateFormatWithTime(formData.signTwoDate) : '') }}</h4>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'

import moment from 'moment'

export default {
  components: {
    BRow,
    BCol,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      logoSrc: require('@/assets/images/logo/nr-logo.png'),
      formData: {},
      loading: true,
      loadError: null,
    }
  },

  created() {
    this.loadFormData()
  },

  methods: {
    // App opens this page in a webview with the saved form's id (route param) - fetches the
    // data the app earlier saved via POST /sales/form/fsp/data instead of reading injected
    // localStorage, which is what the Puppeteer-rendered source form still does.
    //
    // This hits the front-end/ router (optionalAuth, no token required - the id itself is the
    // access control), not reservation-app/ - so this.$http is safe to use here: no 401 is
    // possible, meaning its global interceptor's hard-redirect-to-/login (src/libs/axios.js)
    // never triggers.
    loadFormData() {
      const { id } = this.$route.params
      this.$http.get(`front-end/sales/form/fsp/data/${id}`)
        .then(response => {
          this.formData = response.data.data
          this.loading = false
        })
        .catch(error => {
          this.loadError = (error.response && error.response.data && error.response.data.message) || 'Unable to load form data.'
          this.loading = false
        })
    },
    formatDate(date) {
      if (!date) return '-'
      const timezone = process.env.VUE_APP_TIME_ZONE
      return moment(date).utcOffset(timezone).format('DD/MM/YYYY')
    },
  },
}
</script>

<style>
@media print {
  .page-break-after {
    display: block;
    /* ensure block context */
    page-break-before: always;
    /* legacy */
    break-before: page;
  }

  .formWrapper,
  .niche-wr,
  .ssfp-form-wrapper,
  .ssfp-signature {
    page-break-inside: avoid;
    /* legacy */
    break-inside: avoid;
    /* modern */
  }
}
</style>
